import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import styled, { css } from 'styled-components';
import mq from '../../utils/mediaQueries.js';

var getRowGap = function getRowGap(rowGap) {
  switch (rowGap) {
    case 'none':
      return '0';
    case 'col-gap':
      return 'var(--space-grid-gutter)';
    default:
      return 'var(--space-grid-row-gap)';
  }
};
var Grid = styled.div.withConfig({
  displayName: "Gridstyle__Grid",
  componentId: "sc-9bhwn5-0"
})(["--container-width:1280px;--fluid-area:calc(50% - var(--container-width) / 2);--column-count:3;--m:var(--space-grid-margin);--g:var(--space-grid-gutter);--c:minmax(0,1fr);--container-grid-template:var(--c) repeat(var(--column-count),var(--g) var(--c));--grid-template-areas:'c1 g1 c2 g2 c3 g3 c4';display:grid;grid-template-columns:var(--container-grid-template);grid-template-areas:var(--grid-template-areas);grid-auto-rows:max-content;grid-auto-flow:row;", " ", " ", ""], function (_ref) {
  var $rowGapType = _ref.$rowGapType;
  return css(["row-gap:", ";"], getRowGap($rowGapType));
}, mq.s(css(["--column-count:", ";--grid-template-areas:", ";"], function (_ref2) {
  var $columns = _ref2.$columns;
  return $columns - 1;
}, function (_ref3) {
  var $columns = _ref3.$columns;
  return $columns && "'".concat(_toConsumableArray(Array($columns - 1).keys()).map(function (key) {
    return "c".concat(key + 1, " g").concat(key + 1);
  }).join(' '), " c").concat($columns, "'");
})), function (_ref4) {
  var $root = _ref4.$root;
  return $root && css(["--container-grid-template:var(--fluid-area) max(var(--m),env(safe-area-inset-left)) var(--c) repeat(var(--column-count),var(--g) var(--c)) max(var(--m),env(safe-area-inset-right)) var(--fluid-area);--grid-template-areas:'fa1 m1 c1 g1 c2 g2 c3 g3 c4 m2 fa2';", ""], mq.s(css(["--grid-template-areas:'fa1 m1 c1 g1 c2 g2 c3 g3 c4 g4 c5 g5 c6 g6 c7 g7 c8 g8 c9 g9 c10 g10 c11 g11 c12 m2 fa2';"])));
});
var GridItem = styled.div.withConfig({
  displayName: "Gridstyle__GridItem",
  componentId: "sc-9bhwn5-1"
})(["grid-column:", ";", " ", ""], function (_ref5) {
  var $columnStart = _ref5.$columnStart,
    $columnEnd = _ref5.$columnEnd;
  return "c".concat($columnStart.s + 1, "-start/c").concat($columnEnd.s, "-end");
}, mq.s(css(["grid-column:", ";"], function (_ref6) {
  var $columnStart = _ref6.$columnStart,
    $columnEnd = _ref6.$columnEnd;
  return "c".concat($columnStart.m + 1, "-start/c").concat($columnEnd.m, "-end");
})), mq.m(css(["grid-column:", ";"], function (_ref7) {
  var $columnStart = _ref7.$columnStart,
    $columnEnd = _ref7.$columnEnd;
  return "c".concat($columnStart.l + 1, "-start/c").concat($columnEnd.l, "-end");
})));
var fullWidthStyles = css(["width:calc(100vw - var(--scrollbar,0px));margin-inline:calc(50% - (50vw - var(--scrollbar,0px) / 2));"]);
var GridBleed = styled.div.withConfig({
  displayName: "Gridstyle__GridBleed",
  componentId: "sc-9bhwn5-2"
})(["width:100%;", " ", " ", ""], function (_ref8) {
  var $variant = _ref8.$variant;
  return $variant === 'full' && fullWidthStyles;
}, function (_ref9) {
  var $variant = _ref9.$variant;
  return $variant === 'full-mobile' && mq.sMax(fullWidthStyles);
}, function (_ref10) {
  var $variant = _ref10.$variant;
  return $variant === 'margin-right' && css(["margin-right:calc(var(--space-grid-margin) * -1);width:calc(100% + var(--space-grid-margin));"]);
});

export { Grid, GridBleed, GridItem };
//# sourceMappingURL=Grid.style.js.map
